import { render, staticRenderFns } from "./upper_major.vue?vue&type=template&id=6ac4139b&"
import script from "./upper_major.vue?vue&type=script&lang=js&"
export * from "./upper_major.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports